import React from "react";
import { frameToPercent } from "../../../utils/timelineMath";

interface PlayheadProps {
  currentFrame: number;
  totalFrames: number;
  playheadLabel: string;
  seekLabel: string;
  onPointerDown?: (e: React.PointerEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}

export const Playhead = React.memo(function Playhead({
  currentFrame,
  totalFrames,
  playheadLabel,
  seekLabel,
  onPointerDown,
  disabled = false,
}: PlayheadProps) {
  const leftPercent = frameToPercent(currentFrame, totalFrames) * 100;

  return (
    <div
      aria-label={playheadLabel}
      className="timeline-playhead"
      style={{
        position: "absolute",
        left: `${leftPercent}%`,
        top: -8,
        bottom: -8,
        width: 1,
        backgroundColor: "rgb(250, 204, 21)",
        boxShadow: "0 0 10px rgba(250, 204, 21, 0.45)",
        pointerEvents: "none",
        transform: "translateX(-0.5px)",
      }}
      data-oid="ffpg.zu"
    >
      <button
        type="button"
        aria-label={seekLabel}
        onPointerDown={onPointerDown}
        disabled={disabled}
        className="timeline-playhead-handle"
        style={{
          position: "absolute",
          top: -8,
          left: "50%",
          transform: "translateX(-50%)",
          width: 15,
          height: 15,
          borderRadius: "9999px",
          border: "1px solid rgba(250, 204, 21, 0.95)",
          background: "rgba(250, 204, 21, 0.95)",
          boxShadow:
            "0 0 0 2px rgba(15,23,42,0.65), 0 0 14px rgba(250, 204, 21, 0.5)",
          cursor: disabled ? "not-allowed" : "ew-resize",
          pointerEvents: disabled ? "none" : "auto",
          padding: 0,
        }}
        data-oid=":py6hry"
      />
    </div>
  );
});
